module.exports = __webpack_public_path__ + "img/3.08.thmb.xs.223bc470.jpg";